(function () {
  if (window.__sizeGuideInit) return;
  window.__sizeGuideInit = true;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-size-guide-open]');
    if (trigger) {
      e.preventDefault();
      var slug = trigger.getAttribute('data-size-guide-open');
      var dlg = document.getElementById('size-guide-' + slug);
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
      } else if (dlg) {
        dlg.setAttribute('open', '');
      }
      return;
    }
    var closer = e.target.closest('[data-size-guide-close]');
    if (closer) {
      var parent = closer.closest('dialog');
      if (parent) parent.close();
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('size-guide-modal')) {
      e.target.close();
    }
  });
})();
